import React, { useEffect, useState } from 'react';
import { TextField } from '@mui/material';
import { userEvaluationCreate, userEvaluationUpdate } from 'Api/courseDetailsEvaluations';
import { VALID_GRADE } from 'Constants/Regex';
import styles from './useStyles';
import useTranslation from '../../../Hooks/useTranslation';

const useComponent = (
  editing,
  lessonId,
  setEmployees,
  employees,
  setUnpublishedGrades,
  unpublishedGrades,
  setErrors,
  errors
) => {
  const textFieldStyles = styles.textFieldStyles();
  const { t2 } = useTranslation('Evaluation');

  const handleOnBlur = (grade, userId, userEvaluationId, currentGrade, setError, setErrorMsg, data) => {
    // Make a copy of the affected table row
    const dataCopy = data;

    const errorsCopy = errors;
    errorsCopy[dataCopy[8]] = true;

    if (grade === null) {
      setError(true);
      setErrorMsg(t2('MissingGrade'));
      setErrors(errorsCopy);

      return;
    }

    const validGrade = new RegExp(VALID_GRADE);

    if (!validGrade.test(grade)) {
      setError(true);
      setErrorMsg(t2('InvalidGrade'));
      setErrors(errorsCopy);

      return;
    }

    if (grade < 0 || grade > 100) {
      setError(true);
      setErrorMsg(t2('InvalidGrade'));
      setErrors(errorsCopy);

      return;
    }

    setErrorMsg('');
    setError(false);
    errorsCopy[dataCopy[8]] = false;
    setErrors(errorsCopy);

    // assign it's current grade to be the New Grade from the textfield that passed validation
    dataCopy[5] = parseInt(grade, 10);

    // Since the current row doesn't have an Id, we create a new evaluation
    if (userEvaluationId === null) {
      userEvaluationCreate({
        grade,
        userId,
        lessonId,
        isDraft: true,
      }).then(response => {
        // Now that the evaluation is created assign the new Id to the table row
        dataCopy[7] = response.id;
        // Since we know it's just been created we assign a value of true to IsDraft
        dataCopy[9] = true;

        const employeeCopy = employees;
        // we take the Index of the Affected Row and replace it's old state with the new one
        employeeCopy[dataCopy[8]] = dataCopy;
        setEmployees(employeeCopy);

        const gradesCopy = unpublishedGrades;
        // we take the same index and change the value to true to show there is unpublished evaluations and show button
        gradesCopy[dataCopy[8]] = true;
        setUnpublishedGrades(gradesCopy);
      });
    } else {
      userEvaluationUpdate({
        id: userEvaluationId,
        grade,
      }).then(response => {
        const gradesCopy = unpublishedGrades;
        gradesCopy[dataCopy[8]] = true;
        setUnpublishedGrades(gradesCopy);
      });
    }
  };

  const thereIsComponent = (data, index) => {
    const [error, setError] = useState(false);
    const [errorMsg, setErrorMsg] = useState('');
    const currentGrade = !data[4] ? 0 : data[4];
    const [textFieldValue, setTextFieldValue] = useState(currentGrade);
    const userId = data[6];
    const userEvaluationId = data[7];

    const onChange = event => {
      setTextFieldValue(event.target.value);
    };

    if (index === 4) {
      return (
        <TextField
          value={textFieldValue}
          disabled={!editing}
          style={styles.textField}
          color="success"
          type="tel"
          className={!editing ? textFieldStyles.disabled : textFieldStyles.enabled}
          inputProps={{
            min: 0,
            max: 100,
            maxLength: 3,
            style: { textAlign: 'center' },
          }}
          onBlur={event =>
            handleOnBlur(event.target.value, userId, userEvaluationId, currentGrade, setError, setErrorMsg, data)
          }
          error={error}
          helperText={errorMsg}
          onChange={onChange}
        />
      );
    }
    return data[index];
  };

  return { thereIsComponent };
};

export default useComponent;
